import React from "react";
import { connect } from 'react-redux';
import {
    Switch,
    Route,
    BrowserRouter as Router,
  } from "react-router-dom";
import { RouterProps } from '../types/router';
import WithAuth from '../modules/routes/WithAuth';
import LandingPage from "../pages/landing/LandingPage";
import OuterDashboard from "../layout/dashboard/OuterDashboard";
import InnerDashboard from "../layout/dashboard/InnerDashboard";
import Login from "../pages/auth/Login";
import type { State } from '../modules/state/state';
import { checkOauth } from '../modules/actions/auth';

function RouteModule({ initialized, isAuth, checkOauth }: RouterProps) {
    // Three states
    // 1. if user is authenticated and tries to access a public route like login, redirect them to the home page
    // the home page has 
    // 2. if user is not authenticated and tries to access a private route, redirect them to the login page
    // 3. Else, redirect them to the dashboard page

    if (!initialized) {
        return (
            <Router>
                <Switch>
                    <Route 
                        exact 
                        path="/login" 
                        component={WithAuth(LandingPage, false)} 
                    />
                </Switch>
            </Router>
        );
    }
    
    return (
        <Router>
            <Switch>
                <Route path="/login" component={WithAuth(Login, false)} />
                <Route path="/dashboard/:userId" component={WithAuth(InnerDashboard, true)} />
                <Route path="/" component={WithAuth(OuterDashboard, true)} />
            </Switch>
        </Router>
    );
}

  function mapStateToProps(state: State) {
	return {
		initialized: state.oauth.initialized,
        isAuth: state.oauth.isAuthenticated,
	};
}

const mapDispatchToProps = {
	checkOauth,
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteModule);